import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { BaseRoute, AppRoutes } from '@quizzach/interfaces';
import { AnimatePresence } from 'framer-motion';
import { AccessControlList } from '@quizzach/utils';

// <Navigate> does not interpolate route params, so the redirect target
// has to be built from useParams at render time.
const NavigateToQuizStart = () => {
	const { uuid } = useParams();
	return <Navigate to={`/quiz/${uuid}/start`} replace />;
};

function AnimatedRoutes() {
	// const [loading, setLoading] = useState(true);

	// useEffect(() => {
	// 	const onPageLoad = () => {
	// 		setLoading(false);
	// 	};

	// 	if (document.readyState === 'complete') {
	// 		onPageLoad();
	// 	} else {
	// 		window.addEventListener('load', onPageLoad, false);
	// 		return () => window.removeEventListener('load', onPageLoad);
	// 	}
	// }, []);
	// if (loading) return <h2>loading...</h2>;
	// else

	return (
		<AnimatePresence mode='wait'>
			{/* <Suspense fallback={<></>}> */}
			{/* <Routes location={location} key={location.pathname}> caused rerender of all subroutes on each location prop change, removed it 7.1. */}
			<Routes>
				<Route
					path='/profile'
					element={<Navigate to='/profile/quizzes' replace />}
				/>
				<Route path='/quiz/:uuid' element={<NavigateToQuizStart />} />
				{AppRoutes.map((route: BaseRoute) => (
					<Route
						key={route.key}
						path={route.path}
						element={
							<AccessControlList
								element={<route.component />}
								path={route.path}
								authorizationLevel={route.authorizationLevel}
							/>
						}
					>
						{route.children?.map((child: any) => (
							<Route
								key={child.key}
								path={child.path}
								element={
									<AccessControlList
										element={<child.component />}
										path={child.path}
										authorizationLevel={child.authorizationLevel}
									/>
								}
							/>
						))}
					</Route>
				))}

				<Route path='*' element={<Navigate to='/not-found' replace />} />
			</Routes>
			{/* </Suspense> */}
		</AnimatePresence>
	);
}

export default AnimatedRoutes;
